"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconFile = void 0;

var _styles = require("./styles");

var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");

var _react = _interopRequireWildcard(require("react"));

var _CustomIcon = require("../CustomIcon");

var _jsxRuntime = require("react/jsx-runtime");

var IconFile = function IconFile(props) {
  var _extensions$ext, _extensions$ext$icon, _extensions$ext2;

  var id = props.id,
      key = props.key,
      className = props.className,
      type = props.type,
      transparent = props.transparent,
      size = props.size,
      borderType = props.borderType,
      ext = props.ext;
  var extensions = {
    // file word
    docx: {
      icon: _freeSolidSvgIcons.faFileWord,
      type: "word"
    },
    docm: {
      icon: _freeSolidSvgIcons.faFileWord,
      type: "word"
    },
    doc: {
      icon: _freeSolidSvgIcons.faFileWord,
      type: "word"
    },
    docs: {
      icon: _freeSolidSvgIcons.faFileWord,
      type: "word"
    },
    // file excel
    xls: {
      icon: _freeSolidSvgIcons.faFileExcel,
      type: "excel"
    },
    xlsm: {
      icon: _freeSolidSvgIcons.faFileExcel,
      type: "excel"
    },
    xlsx: {
      icon: _freeSolidSvgIcons.faFileExcel,
      type: "excel"
    },
    tsv: {
      icon: _freeSolidSvgIcons.faFileExcel,
      type: "excel"
    },
    // file csv
    csv: {
      icon: _freeSolidSvgIcons.faFileCsv,
      type: "csv"
    },
    // file image
    svg: {
      icon: _freeSolidSvgIcons.faFileImage,
      type: "image"
    },
    gif: {
      icon: _freeSolidSvgIcons.faFileImage,
      type: "image"
    },
    // file pdf
    pdf: {
      icon: _freeSolidSvgIcons.faFilePdf,
      type: "pdf"
    },
    // file power point
    pot: {
      icon: _freeSolidSvgIcons.faFilePowerpoint,
      type: "powerPoint"
    },
    potm: {
      icon: _freeSolidSvgIcons.faFilePowerpoint,
      type: "powerPoint"
    },
    potx: {
      icon: _freeSolidSvgIcons.faFilePowerpoint,
      type: "powerPoint"
    },
    pps: {
      icon: _freeSolidSvgIcons.faFilePowerpoint,
      type: "powerPoint"
    },
    ppsm: {
      icon: _freeSolidSvgIcons.faFilePowerpoint,
      type: "powerPoint"
    },
    ppsx: {
      icon: _freeSolidSvgIcons.faFilePowerpoint,
      type: "powerPoint"
    },
    ppt: {
      icon: _freeSolidSvgIcons.faFilePowerpoint,
      type: "powerPoint"
    },
    pptm: {
      icon: _freeSolidSvgIcons.faFilePowerpoint,
      type: "powerPoint"
    },
    pptx: {
      icon: _freeSolidSvgIcons.faFilePowerpoint,
      type: "powerPoint"
    },
    // file zip
    rar: {
      icon: _freeSolidSvgIcons.faFileZipper,
      type: "zip"
    },
    zip: {
      icon: _freeSolidSvgIcons.faFileZipper,
      type: "zip"
    },
    tar: {
      icon: _freeSolidSvgIcons.faFileZipper,
      type: "zip"
    },
    // file code
    xml: {
      icon: _freeSolidSvgIcons.faFileCode,
      type: "code"
    },
    htm: {
      icon: _freeSolidSvgIcons.faFileCode,
      type: "code"
    },
    html: {
      icon: _freeSolidSvgIcons.faFileCode,
      type: "code"
    },
    css: {
      icon: _freeSolidSvgIcons.faFileCode,
      type: "code"
    },
    js: {
      icon: _freeSolidSvgIcons.faFileCode,
      type: "code"
    },
    jsx: {
      icon: _freeSolidSvgIcons.faFileCode,
      type: "code"
    },
    ts: {
      icon: _freeSolidSvgIcons.faFileCode,
      type: "code"
    },
    tsx: {
      icon: _freeSolidSvgIcons.faFileCode,
      type: "code"
    },
    cpp: {
      icon: _freeSolidSvgIcons.faFileCode,
      type: "code"
    },
    c: {
      icon: _freeSolidSvgIcons.faFileCode,
      type: "code"
    },
    java: {
      icon: _freeSolidSvgIcons.faFileCode,
      type: "code"
    },
    php: {
      icon: _freeSolidSvgIcons.faFileCode,
      type: "code"
    },
    json: {
      icon: _freeSolidSvgIcons.faFileCode,
      type: "code"
    },
    sql: {
      icon: _freeSolidSvgIcons.faFileCode,
      type: "code"
    },
    // file video
    avi: {
      icon: _freeSolidSvgIcons.faFileVideo,
      type: "video"
    },
    mp4: {
      icon: _freeSolidSvgIcons.faFileVideo,
      type: "video"
    },
    mpeg: {
      icon: _freeSolidSvgIcons.faFileVideo,
      type: "video"
    },
    mpg: {
      icon: _freeSolidSvgIcons.faFileVideo,
      type: "video"
    },
    wmv: {
      icon: _freeSolidSvgIcons.faFileVideo,
      type: "video"
    },
    // file audio
    m4a: {
      icon: _freeSolidSvgIcons.faFileAudio,
      type: "audio"
    },
    mp3: {
      icon: _freeSolidSvgIcons.faFileAudio,
      type: "audio"
    },
    wav: {
      icon: _freeSolidSvgIcons.faFileAudio,
      type: "audio"
    },
    wma: {
      icon: _freeSolidSvgIcons.faFileAudio,
      type: "audio"
    }
  };
  var ref = (0, _react.useRef)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Container, {
      className: className + (!type && (_extensions$ext = extensions[ext]) !== null && _extensions$ext !== void 0 && _extensions$ext.type ? " icon-" + extensions[ext].type : undefined),
      borderType: borderType,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CustomIcon.CustomIcon, {
        id: id,
        className: "icon",
        type: type,
        transparent: transparent,
        borderType: borderType,
        size: size,
        icon: (_extensions$ext$icon = (_extensions$ext2 = extensions[ext]) === null || _extensions$ext2 === void 0 ? void 0 : _extensions$ext2.icon) !== null && _extensions$ext$icon !== void 0 ? _extensions$ext$icon : _freeSolidSvgIcons.faFileLines
      }, key)
    })
  });
};

exports.IconFile = IconFile;